const communityRoutes = [
  {
    path: "community",
    meta: {
      title: "커뮤니티",
      titleEn: "Community",
    },
    children: [
      {
        path: "banner", // ecp/category
        meta: {
          title: "메인배너 관리",
          titleEn: "Main Banner Management",
          isDynamic: true,
          menuCd: "COMMUNITY_BANNER_MNG",
        },
        component: () => import("@/views/community/banners/BannerIndex.vue"),
      },
      {
        path: "noticeMng", // ecp/noticeMng
        meta: {
          title: "공지사항",
          titleEn: "Notification item management",
          isDynamic: true,
          menuCd: "COMMUNITY_NOTICE_MNG",
        },
        children: [
          {
            path: "",
            meta: {
              title: "공지사항 관리",
              isDynamic: true,
            },
            component: () => import("@/views/community/notice/NoticeIndex.vue"),
          },
          {
            path: "reg",
            meta: {
              title: "공지사항 등록",
              isDynamic: true,
            },
            component: () => import("@/views/community/notice/NoticeReg.vue"),
          },
          {
            path: "detail",
            meta: {
              title: "공지사항 조회",
              isDynamic: true,
            },
            component: () => import("@/views/community/notice/NoticeDetail.vue"),
          },
        ],
      },
      {
        path: "qna", // ecp/qna
        meta: {
          title: "Q&A 관리",
          titleEn: "Q&A",
          isDynamic: true,
          menuCd: "COMMUNITY_QNA_MNG",
        },
        children: [
          {
            path: "",
            meta: {
              title: "Q&A 관리",
              isDynamic: true,
            },
            component: () => import("@/views/community/qna/QnaIndex.vue"),
          },
          {
            path: "update",
            meta: {
              title: "Q&A 답변하기",
              isDynamic: true,
            },
            component: () => import("@/views/community/qna/QnaReg.vue"),
          },
          {
            path: "detail",
            meta: {
              title: "Q&A",
              isDynamic: true,
            },
            component: () => import("@/views/community/qna/QnaDetail.vue"),
          },
        ],
      },
      {
        path: "msg",
        meta: {
          title: "알림톡",
          titleEn: "Alert",
          isDynamic: true,
          menuCd: "COMMUNITY_MSG_MNG",
        },
        children: [
          {
            path: "",
            meta: {
              title: "알림톡",
              isDynamic: true,
            },
            component: () => import("@/views/community/alert/MsgSendMngIndex.vue"),
          },
          {
            path: "reg",
            meta: {
              title: "알림톡 발송",
              isDynamic: true,
            },
            component: () => import("@/views/community/alert/MsgSendMngRegInHa.vue"),
          },
        ],
      },
    ],
  },
];

export default communityRoutes;
